export var ServiceName;
(function (ServiceName) {
    ServiceName["TENDER_DOCUMENTS"] = "tender-documents";
    ServiceName["OFFER"] = "offer";
    ServiceName["BID_REVIEW"] = "bid-review";
    ServiceName["TENANT_SPECIFICATION"] = "tenant-specification";
    ServiceName["TENANT_REQUIREMENTS"] = "tenant-requirements";
    ServiceName["DUE_DILIGENCE"] = "due-diligence";
    ServiceName["SITE_DUE_DILIGENCE"] = "site-due-diligence";
    ServiceName["MANAGEMENT_OPERATIONS_MAINTENANCE"] = "management-operations-maintenance";
    ServiceName["PLANT_ROOM"] = "plant-room";
    ServiceName["CEILING_PLAN"] = "ceiling-plan";
    ServiceName["FLOOR_PLAN"] = "floor-plan";
    ServiceName["SPACE_ANALYSIS"] = "space-analysis";
    ServiceName["PARKING"] = "parking";
    ServiceName["REPORTS"] = "reports";
    ServiceName["REPORT_GENERATION"] = "report-generation";
    ServiceName["STRUCTURAL"] = "structural";
    ServiceName["CEILING_GRID"] = "ceiling-grid";
    ServiceName["LOAD_CALCULATION"] = "load-calculation";
    ServiceName["MEETING_SECRETARY"] = "meeting-secretary";
    ServiceName["SCHEDULE_CHECK"] = "schedule-check";
    ServiceName["CONTRACT_REVIEW"] = "contract-review";
    ServiceName["SOLUTION_VIEWER"] = "solution-viewer";
    ServiceName["LUMINAIRE_SCHEDULE"] = "luminaire-schedule";
    ServiceName["RFP_RFQ_REVIEW"] = "rfp-rfq-review";
    ServiceName["DESIGN_PACKAGE_REVIEW"] = "design-package-review";
    ServiceName["QA_AGENT"] = "qa-agent";
    ServiceName["CODE_RESEARCH_AGENT"] = "code-research-agent";
    ServiceName["VERSION_COMPARE"] = "version-compare";
    ServiceName["WATER_PROCESS_SYSTEMS_AGENT"] = "water-process-systems-agent";
    ServiceName["GEOTECHNICAL_EXTRACTION_AGENT"] = "geotechnical-extraction-agent";
    ServiceName["ENVIRONMENT_REPORT_AGENT"] = "environment-report-agent";
    ServiceName["LIGHTNING_DESIGNER"] = "lightning-designer";
})(ServiceName || (ServiceName = {}));
export var ServiceNameType;
(function (ServiceNameType) {
    ServiceNameType["TENDER_DOCUMENTS"] = "TENDER_DOCUMENTS";
    ServiceNameType["OFFER"] = "OFFER";
    ServiceNameType["BID_REVIEW"] = "BID_REVIEW";
    ServiceNameType["TENANT_SPECIFICATION"] = "TENANT_SPECIFICATION";
    ServiceNameType["TENANT_REQUIREMENTS"] = "TENANT_REQUIREMENTS";
    ServiceNameType["DUE_DILIGENCE"] = "DUE_DILIGENCE";
    ServiceNameType["SITE_DUE_DILIGENCE"] = "SITE_DUE_DILIGENCE";
    ServiceNameType["MANAGEMENT_OPERATIONS_MAINTENANCE"] = "MANAGEMENT_OPERATIONS_MAINTENANCE";
    ServiceNameType["PLANT_ROOM"] = "PLANT_ROOM";
    ServiceNameType["CEILING_PLAN"] = "CEILING_PLAN";
    ServiceNameType["FLOOR_PLAN"] = "FLOOR_PLAN";
    ServiceNameType["SPACE_ANALYSIS"] = "SPACE_ANALYSIS";
    ServiceNameType["PARKING"] = "PARKING";
    ServiceNameType["REPORTS"] = "REPORTS";
    ServiceNameType["REPORT_GENERATION"] = "REPORT_GENERATION";
    ServiceNameType["STRUCTURAL"] = "STRUCTURAL";
    ServiceNameType["CEILING_GRID"] = "CEILING_GRID";
    ServiceNameType["LOAD_CALCULATION"] = "LOAD_CALCULATION";
    ServiceNameType["MEETING_SECRETARY"] = "MEETING_SECRETARY";
    ServiceNameType["SOLUTION_VIEWER"] = "SOLUTION_VIEWER";
    ServiceNameType["DATA_CENTER"] = "DATA_CENTER";
    ServiceNameType["WASTEWATER_TREATMENT"] = "WASTEWATER_TREATMENT";
    ServiceNameType["SCHEDULE_CHECK"] = "SCHEDULE_CHECK";
    ServiceNameType["CONTRACT_REVIEW"] = "CONTRACT_REVIEW";
    ServiceNameType["LUMINAIRE_SCHEDULE"] = "LUMINAIRE_SCHEDULE";
    ServiceNameType["RFP_RFQ_REVIEW"] = "RFP_RFQ_REVIEW";
    ServiceNameType["DESIGN_PACKAGE_REVIEW"] = "DESIGN_PACKAGE_REVIEW";
    ServiceNameType["QA_AGENT"] = "QA_AGENT";
    ServiceNameType["CODE_RESEARCH_AGENT"] = "CODE_RESEARCH_AGENT";
    ServiceNameType["VERSION_COMPARE"] = "VERSION_COMPARE";
    ServiceNameType["WATER_PROCESS_SYSTEMS_AGENT"] = "WATER_PROCESS_SYSTEMS_AGENT";
    ServiceNameType["GEOTECHNICAL_EXTRACTION_AGENT"] = "GEOTECHNICAL_EXTRACTION_AGENT";
    ServiceNameType["ENVIRONMENT_REPORT_AGENT"] = "ENVIRONMENT_REPORT_AGENT";
    ServiceNameType["LIGHTNING_DESIGNER"] = "LIGHTNING_DESIGNER";
})(ServiceNameType || (ServiceNameType = {}));
export var ServicePermissionName;
(function (ServicePermissionName) {
    ServicePermissionName["USE_TENDER_DOCUMENTS_SERVICE"] = "use_tender_documents_service";
    ServicePermissionName["USE_OFFER_SERVICE"] = "use_offer_service";
    ServicePermissionName["USE_TENANT_SPEC_SERVICE"] = "use_tenant_spec_service";
    ServicePermissionName["USE_TENANT_REQ_SERVICE"] = "use_tenant_req_service";
    ServicePermissionName["USE_DUE_DILIGENCE_SERVICE"] = "use_due_diligence_service";
    ServicePermissionName["USE_SITE_DUE_DILIGENCE_SERVICE"] = "use_site_due_diligence_service";
    ServicePermissionName["USE_MANAGE_OPERATE_SERVICE"] = "use_manage_operate_service";
    ServicePermissionName["USE_PLANT_ROOM_SERVICE"] = "use_plant_room_service";
    ServicePermissionName["USE_CEILING_PLAN_SERVICE"] = "use_ceiling_plan_service";
    ServicePermissionName["USE_FLOOR_PLAN_SERVICE"] = "use_floor_plan_service";
    ServicePermissionName["USE_SPACE_ANALYSIS_SERVICE"] = "use_space_analysis_service";
    ServicePermissionName["USE_PARKING_SERVICE"] = "use_parking_service";
    ServicePermissionName["USE_REPORTS_SERVICE"] = "use_reports_service";
    ServicePermissionName["USE_REPORT_GENERATION_SERVICE"] = "use_report_generation_service";
    ServicePermissionName["USE_STRUCTURAL_SERVICE"] = "use_structural_service";
    ServicePermissionName["USE_CEILING_GRID_SERVICE"] = "use_ceiling_grid_service";
    ServicePermissionName["USE_LOAD_CALCULATION_SERVICE"] = "use_load_calculation_service";
    ServicePermissionName["USE_MEETING_SECRETARY_SERVICE"] = "use_meeting_secretary_service";
    ServicePermissionName["USE_SCHEDULE_CHECK_SERVICE"] = "use_schedule_check_service";
    ServicePermissionName["USE_CONTRACT_REVIEW_SERVICE"] = "use_contract_review_service";
    ServicePermissionName["USE_SOLUTION_VIEWER_SERVICE"] = "use_solution_viewer_service";
    ServicePermissionName["USE_LUMINAIRE_SCHEDULE_SERVICE"] = "use_luminaire_schedule_service";
    ServicePermissionName["USE_RFP_RFQ_REVIEW_SERVICE"] = "use_rfp_rfq_review_service";
    ServicePermissionName["USE_DESIGN_PACKAGE_REVIEW_SERVICE"] = "use_design_package_review_service";
    ServicePermissionName["USE_QA_AGENT_SERVICE"] = "use_qa_agent_service";
    ServicePermissionName["USE_CODE_RESEARCH_AGENT_SERVICE"] = "use_code_research_agent_service";
    ServicePermissionName["USE_VERSION_COMPARE_SERVICE"] = "use_version_compare_service";
    ServicePermissionName["USE_WATER_PROCESS_SYSTEMS_AGENT_SERVICE"] = "use_water_process_systems_agent_service";
    ServicePermissionName["USE_GEOTECHNICAL_EXTRACTION_AGENT_SERVICE"] = "use_geotechnical_extraction_agent_service";
    ServicePermissionName["USE_ENVIRONMENT_REPORT_AGENT_SERVICE"] = "use_environment_report_agent_service";
    ServicePermissionName["USE_LIGHTNING_DESIGNER_SERVICE"] = "use_lightning_designer_service";
})(ServicePermissionName || (ServicePermissionName = {}));
export var ServiceCategory;
(function (ServiceCategory) {
    ServiceCategory["INSIGHT"] = "INSIGHT";
    ServiceCategory["LAYOUT_OPTIMIZATION"] = "LAYOUT_OPTIMIZATION";
    ServiceCategory["STRUCTURAL_ENGINEERING"] = "STRUCTURAL_ENGINEERING";
    ServiceCategory["BUILDING_PACKAGE"] = "BUILDING_PACKAGE";
    ServiceCategory["MEETING_SECRETARY"] = "MEETING_SECRETARY";
    ServiceCategory["SCHEDULE_CHECK"] = "SCHEDULE_CHECK";
    ServiceCategory["LUMINAIRE_SCHEDULE"] = "LUMINAIRE_SCHEDULE";
    ServiceCategory["REPORT_GENERATION"] = "REPORT_GENERATION";
})(ServiceCategory || (ServiceCategory = {}));
export const ServiceNameTypeLabels = {
    [ServiceNameType.TENDER_DOCUMENTS]: 'Tender Review',
    [ServiceNameType.OFFER]: 'Bid Review',
    [ServiceNameType.BID_REVIEW]: 'Offer (Bid Review)',
    [ServiceNameType.TENANT_SPECIFICATION]: 'Tenant Specification',
    [ServiceNameType.TENANT_REQUIREMENTS]: 'Tenant Requirements',
    [ServiceNameType.DUE_DILIGENCE]: 'Due Diligence',
    [ServiceNameType.SITE_DUE_DILIGENCE]: 'Site Due Diligence',
    [ServiceNameType.MANAGEMENT_OPERATIONS_MAINTENANCE]: 'Handover',
    [ServiceNameType.PLANT_ROOM]: 'Plant Room',
    [ServiceNameType.CEILING_PLAN]: 'Ceiling Plan',
    [ServiceNameType.FLOOR_PLAN]: 'Floor Plan',
    [ServiceNameType.SPACE_ANALYSIS]: 'Space Analysis',
    [ServiceNameType.PARKING]: 'Parking',
    [ServiceNameType.REPORTS]: 'Reports',
    [ServiceNameType.REPORT_GENERATION]: 'Report Generation',
    [ServiceNameType.STRUCTURAL]: 'Structural',
    [ServiceNameType.CEILING_GRID]: 'Ceiling Grid',
    [ServiceNameType.LOAD_CALCULATION]: 'Load Calculation',
    [ServiceNameType.MEETING_SECRETARY]: 'Meeting Assistant',
    [ServiceNameType.SOLUTION_VIEWER]: 'Solution Viewer',
    [ServiceNameType.DATA_CENTER]: 'Data Center',
    [ServiceNameType.WASTEWATER_TREATMENT]: 'Wastewater treatment',
    [ServiceNameType.SCHEDULE_CHECK]: 'Component Reference Checker',
    [ServiceNameType.CONTRACT_REVIEW]: 'Contract Review',
    [ServiceNameType.LUMINAIRE_SCHEDULE]: 'Luminaire Schedule',
    [ServiceNameType.RFP_RFQ_REVIEW]: 'RFP Review',
    [ServiceNameType.DESIGN_PACKAGE_REVIEW]: 'Design Package Review',
    [ServiceNameType.QA_AGENT]: 'Model Review Agent',
    [ServiceNameType.CODE_RESEARCH_AGENT]: 'Code Research Agent',
    [ServiceNameType.VERSION_COMPARE]: 'Version Compare',
    [ServiceNameType.WATER_PROCESS_SYSTEMS_AGENT]: 'Water & Process Systems Agent',
    [ServiceNameType.GEOTECHNICAL_EXTRACTION_AGENT]: 'Geotechnical Extraction Agent',
    [ServiceNameType.ENVIRONMENT_REPORT_AGENT]: 'Environment Report Agent',
    [ServiceNameType.LIGHTNING_DESIGNER]: 'Lightning Designer',
};
export const ServiceNameLabels = {
    [ServiceName.TENDER_DOCUMENTS]: 'Tender Review',
    [ServiceName.OFFER]: 'Bid Review',
    [ServiceName.BID_REVIEW]: 'Offer (Bid Review)',
    [ServiceName.TENANT_SPECIFICATION]: 'Tenant Specification',
    [ServiceName.TENANT_REQUIREMENTS]: 'Tenant Requirements',
    [ServiceName.DUE_DILIGENCE]: 'Due Diligence',
    [ServiceName.SITE_DUE_DILIGENCE]: 'Site Due Diligence',
    [ServiceName.MANAGEMENT_OPERATIONS_MAINTENANCE]: 'Handover',
    [ServiceName.PLANT_ROOM]: 'Plant Room',
    [ServiceName.CEILING_PLAN]: 'Ceiling Plan',
    [ServiceName.FLOOR_PLAN]: 'Floor Plan',
    [ServiceName.SPACE_ANALYSIS]: 'Space Analysis',
    [ServiceName.PARKING]: 'Parking',
    [ServiceName.REPORTS]: 'Reports',
    [ServiceName.REPORT_GENERATION]: 'Report Generation',
    [ServiceName.STRUCTURAL]: 'Structural',
    [ServiceName.CEILING_GRID]: 'Ceiling Grid',
    [ServiceName.LOAD_CALCULATION]: 'Load Calculation',
    [ServiceName.MEETING_SECRETARY]: 'Meeting Assistant',
    [ServiceName.SOLUTION_VIEWER]: 'Solution Viewer',
    [ServiceName.SCHEDULE_CHECK]: 'Component Reference Checker',
    [ServiceName.CONTRACT_REVIEW]: 'Contract Review',
    [ServiceName.LUMINAIRE_SCHEDULE]: 'Luminaire Schedule',
    [ServiceName.RFP_RFQ_REVIEW]: 'RFP Review',
    [ServiceName.DESIGN_PACKAGE_REVIEW]: 'Design Package Review',
    [ServiceName.QA_AGENT]: 'Model Review Agent',
    [ServiceName.CODE_RESEARCH_AGENT]: 'Code Research Agent',
    [ServiceName.VERSION_COMPARE]: 'Version Compare',
    [ServiceName.WATER_PROCESS_SYSTEMS_AGENT]: 'Water & Process Systems Agent',
    [ServiceName.GEOTECHNICAL_EXTRACTION_AGENT]: 'Geotechnical Extraction Agent',
    [ServiceName.ENVIRONMENT_REPORT_AGENT]: 'Environment Report Agent',
    [ServiceName.LIGHTNING_DESIGNER]: 'Lightning Designer',
};
export const ServicePermissionLabels = {
    [ServicePermissionName.USE_TENDER_DOCUMENTS_SERVICE]: 'Tender Review',
    [ServicePermissionName.USE_OFFER_SERVICE]: 'Bid Review',
    [ServicePermissionName.USE_TENANT_SPEC_SERVICE]: 'Tenant Specification',
    [ServicePermissionName.USE_TENANT_REQ_SERVICE]: 'Tenant Requirements',
    [ServicePermissionName.USE_DUE_DILIGENCE_SERVICE]: 'Due Diligence',
    [ServicePermissionName.USE_SITE_DUE_DILIGENCE_SERVICE]: 'Site Due Diligence',
    [ServicePermissionName.USE_MANAGE_OPERATE_SERVICE]: 'Handover',
    [ServicePermissionName.USE_PLANT_ROOM_SERVICE]: 'Plant Room',
    [ServicePermissionName.USE_CEILING_PLAN_SERVICE]: 'Ceiling Plan',
    [ServicePermissionName.USE_FLOOR_PLAN_SERVICE]: 'Floor Plan',
    [ServicePermissionName.USE_SPACE_ANALYSIS_SERVICE]: 'Space Analysis',
    [ServicePermissionName.USE_PARKING_SERVICE]: 'Parking',
    [ServicePermissionName.USE_REPORTS_SERVICE]: 'Reports',
    [ServicePermissionName.USE_REPORT_GENERATION_SERVICE]: 'Report Generation',
    [ServicePermissionName.USE_STRUCTURAL_SERVICE]: 'Structural',
    [ServicePermissionName.USE_CEILING_GRID_SERVICE]: 'Ceiling Grid',
    [ServicePermissionName.USE_LOAD_CALCULATION_SERVICE]: 'Load Calculation',
    [ServicePermissionName.USE_MEETING_SECRETARY_SERVICE]: 'Meeting Assistant',
    [ServicePermissionName.USE_SCHEDULE_CHECK_SERVICE]: 'Component Reference Checker',
    [ServicePermissionName.USE_CONTRACT_REVIEW_SERVICE]: 'Contract Review',
    [ServicePermissionName.USE_SOLUTION_VIEWER_SERVICE]: 'Solution Viewer',
    [ServicePermissionName.USE_LUMINAIRE_SCHEDULE_SERVICE]: 'Luminaire Schedule',
    [ServicePermissionName.USE_RFP_RFQ_REVIEW_SERVICE]: 'RFP Review',
    [ServicePermissionName.USE_DESIGN_PACKAGE_REVIEW_SERVICE]: 'Design Package Review',
    [ServicePermissionName.USE_QA_AGENT_SERVICE]: 'Model Review Agent',
    [ServicePermissionName.USE_CODE_RESEARCH_AGENT_SERVICE]: 'Code Research Agent',
    [ServicePermissionName.USE_VERSION_COMPARE_SERVICE]: 'Version Compare',
    [ServicePermissionName.USE_WATER_PROCESS_SYSTEMS_AGENT_SERVICE]: 'Water & Process Systems Agent',
    [ServicePermissionName.USE_GEOTECHNICAL_EXTRACTION_AGENT_SERVICE]: 'Geotechnical Extraction Agent',
    [ServicePermissionName.USE_ENVIRONMENT_REPORT_AGENT_SERVICE]: 'Environment Report Agent',
    [ServicePermissionName.USE_LIGHTNING_DESIGNER_SERVICE]: 'Lightning Designer',
};
export const ServiceCategoryLabels = {
    [ServiceCategory.INSIGHT]: 'Insight Package',
    [ServiceCategory.LAYOUT_OPTIMIZATION]: 'Layout Optimization',
    [ServiceCategory.STRUCTURAL_ENGINEERING]: 'Structural Engineering',
    [ServiceCategory.BUILDING_PACKAGE]: 'Building Package',
    [ServiceCategory.MEETING_SECRETARY]: 'Meeting Assistant',
    [ServiceCategory.SCHEDULE_CHECK]: 'Component Reference Checker',
    [ServiceCategory.REPORT_GENERATION]: 'Technical Report Writer',
    [ServiceCategory.LUMINAIRE_SCHEDULE]: 'Luminaire Schedule',
};
export var SolutionViewerType;
(function (SolutionViewerType) {
    SolutionViewerType["SOLUTION_VIEWER"] = "SOLUTION_VIEWER";
})(SolutionViewerType || (SolutionViewerType = {}));
export var QaAgentType;
(function (QaAgentType) {
    QaAgentType["QA_AGENT"] = "QA_AGENT";
})(QaAgentType || (QaAgentType = {}));
export var ServiceEntityType;
(function (ServiceEntityType) {
    ServiceEntityType["BUILDING_PACKAGE"] = "BUILDING_PACKAGE";
    ServiceEntityType["DOCUMENT_PACKAGE"] = "DOCUMENT_PACKAGE";
    ServiceEntityType["LAYOUT_OPTIMIZATION"] = "LAYOUT_OPTIMIZATION";
})(ServiceEntityType || (ServiceEntityType = {}));
export const ServiceEntityTypeLabels = {
    [ServiceEntityType.BUILDING_PACKAGE]: 'Building Package',
    [ServiceEntityType.DOCUMENT_PACKAGE]: 'Insight Package',
    [ServiceEntityType.LAYOUT_OPTIMIZATION]: 'Layout Optimization',
};
